import { Component } from '@angular/core';

@Component({
  selector: 'app-concluido',
  templateUrl: './concluido.component.html',
  styleUrls: ['./concluido.component.scss']
})
export class ConcluidoComponent {}
